import loginTemplate from './login.html';
import resetPasswordTemplate from './resetPassword.html';
import signUpTemplate from './signUp.html';
import userTemplate from './user.html';
import changeUserTemplate from './changeUser.html';

/* @ngInject */
const UserConfig = ($stateProvider) => {
    $stateProvider
        .state('login', {
            url: '/login',
            template: loginTemplate,
            controller: 'LoginController',
            controllerAs: 'login'
        })
        .state('resetPassword', {
            url: '/reset',
            template: resetPasswordTemplate,
            controller: 'ResetPasswordController',
            controllerAs: 'resetPassword'
        })
        .state('signUp', {
            url: '/signup',
            template: signUpTemplate,
            controller: 'SignUpController',
            controllerAs: 'signUp'
        })
        .state('user', {
            url: '/userinfo',
            template: userTemplate,
            controller: 'UserController',
            controllerAs: 'user'
        })
        .state('changeUser', {
            url: '/user',
            template: changeUserTemplate,
            controller: 'ChangeUserController',
            controllerAs: 'changeUser'
        });
};

export default UserConfig;



/** WEBPACK FOOTER **
 ** ./src/app/components/user/user.config.js
 **/